module.exports = __webpack_public_path__ + "v1.8.4.20261010/img/007.0a6517e8.png";